import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./AddVanLicense.css";
import { Autocomplete, Input, TextField } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import { POST_LICENSE } from "../../URLs/Apis";
import { toast } from "react-toastify";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { useSelector } from "react-redux";

const AddVanLicense = ({ getLicenseData, show, handleClose }) => {
  const [licenseTypes, setLicenseTypes] = useState([]);
  // const [licensePhoto, setLicensePhoto] = useState(null);

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  // const [addMainCatigory, setAddMainCatigory] = useState({
  //   image: "",
  //   description: "",
  //   name: "",
  //   status: "",
  // });

  // const [show, setShow] = useState(false);

  // const handleShow = () => {
  //   setAddMainCatigory({
  //     image: "",
  //     fileUrl: "",
  //     name: "",
  //     description: "",
  //     status: "",
  //   });
  //   // setIsEditing(false);
  //   // setEditCategoryId(null);
  //   setShow(true);
  // };

  // const handleClose = () => {
  //   setShow(false);
  //   // setIsEditing(false)
  //   // setEditCategoryId(null);
  // };

  //  const getLicenseTypes = async ()=>{
  //   try {
  //     let response = await axios.get(`${baseUrl}/api/license_types` , {
  //       headers:{Authorization:`Bearer ${token}`},
  //     });
  //     console.log(response.data.data.license_types);
  //     setLicenseTypes(response.data.data.license_types);
  //   } catch (error) {
  //     console.error("Error fetching license types:", error.message);
  //   }
  // };

  // useEffect(() => {
  //   getLicenseTypes();
  // }, []);

  return <p>ggg</p>;
};

export default AddVanLicense;
